import { Component, EventEmitter, Input, Output } from '@angular/core'
import { ICON_TYPE } from '@spartacus/storefront'
import { ICustomCard } from '../../../models/interface/card.interface'

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    standalone: false
})
export class CardComponent {
  iconTypes = ICON_TYPE

  @Output()
  deleteCard: EventEmitter<number> = new EventEmitter()
  @Output()
  setDefaultCard: EventEmitter<number> = new EventEmitter()
  @Output()
  sendCard: EventEmitter<number> = new EventEmitter()
  @Output()
  editCard: EventEmitter<number> = new EventEmitter()
  @Output()
  cancelCard: EventEmitter<number> = new EventEmitter()

  @Input()
  border = false

  @Input()
  editMode = false

  @Input()
  isDefault = false

  @Input()
  content: ICustomCard
  @Input()
  fitToContainer = false

  // ACTIONS

  setEditMode(): void {
    this.editMode = true
  }

  cancelEdit(): void {
    this.editMode = false
    this.cancelCard.emit(5)
  }

  delete(): void {
    this.deleteCard.emit(1)
  }

  setDefault(): void {
    this.isDefault = true
    this.setDefaultCard.emit(2)
  }

  send(): void {
    this.sendCard.emit(3)
  }

  edit(): void {
    this.editCard.emit(4)
  }

  constructor() {}
}
